"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStepRange = void 0;
var gherkin_utils_1 = require("@cucumber/gherkin-utils");
var vscode_languageserver_types_1 = require("vscode-languageserver-types");
var parseGherkinDocument_js_1 = require("../gherkin/parseGherkinDocument.js");
function getStepRange(gherkinSource, position) {
    var gherkinDocument = (0, parseGherkinDocument_js_1.parseGherkinDocument)(gherkinSource).gherkinDocument;
    if (!gherkinDocument) {
        return undefined;
    }
    var stepKeyword = undefined;
    var stepText = undefined;
    var range = undefined;
    (0, gherkin_utils_1.walkGherkinDocument)(gherkinDocument, undefined, {
        step: function (step) {
            if (step.location.line === position.line + 1 && step.location.column !== undefined) {
                stepText = step.text;
                stepKeyword = step.keyword;
                var startCharacter = step.location.column + step.keyword.length - 1;
                var endCharacter = startCharacter + stepText.length;
                range = vscode_languageserver_types_1.Range.create(position.line, startCharacter, position.line, endCharacter);
            }
        },
    });
    if (stepKeyword && stepText && range) {
        return {
            stepKeyword: stepKeyword,
            stepText: stepText,
            range: range,
        };
    }
}
exports.getStepRange = getStepRange;
//# sourceMappingURL=helpers.js.map